// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1uFKM","empty":"ModalGraph_empty__10FQ_"};